
// export default GraphCard;
import React from "react";
import Chart from "react-apexcharts";

const GraphCard = ({ title, seriesData, categories }) => {
  const chartOptions = {
    chart: {
      type: "line",
      height: 300,
      toolbar: { show: false },
    },
    colors: [
      "#1C2B2C",
      "#785C99",
      "#B51A12",
      "#E33A31",
      "#3176A0",
      "#FFB82A",
    ],
    stroke: {
      curve: "smooth",
      width: 2,
    },

    // ✅ Y-axis fix
    yaxis: {
      min: 0,               // Y-axis start from 0
      forceNiceScale: true, // Clean scale automatically
      decimalsInFloat: 0,   // No decimal values
      labels: {
        formatter: function (val) {
          return Math.round(val); // Show only integers
        }
      }
    },

    tooltip: {
      shared: true,
      intersect: false,
      custom: function ({ dataPointIndex, w }) {
        const month = w.globals.categoryLabels[dataPointIndex];
        const values = w.config.series.map((s) => s.data[dataPointIndex] || 0);
        const total = values.reduce((sum, v) => sum + v, 0);

        const statusLabels = [
          "Completed",
          "Assigned",
          "Declined",
          "Cancelled",
          "Pending",
          "Available",
        ];

        let html = `<div style="padding:10px;"><strong style="font-size:14px;">${month}</strong><br/><br/>`;

        values.forEach((val, i) => {
          html += `
            <div style="display:flex; align-items:center; margin-bottom:3px;">
              <span style="display:inline-block; width:8px; height:8px; background:${chartOptions.colors[i]}; border-radius:50%; margin-right:6px;"></span>
              <span>${statusLabels[i]}:</span>
              <span style="margin-left:4px;">${val}</span>
            </div>`;
        });

        html += `<hr style="margin:6px 0;" /><strong>Total: ${total}</strong></div>`;
        return html;
      },
    },

    xaxis: {
      categories: categories,
    },
    title: {
      text: title,
      align: "left",
      style: { fontSize: "14px", fontWeight: "bold" },
    },
  };

  return <Chart options={chartOptions} series={seriesData} type="line" height={300} />;
};

export default GraphCard;
